import * as yup from "yup";

const parseCurrency = (raw) => {
  if (raw === null || raw === undefined) return NaN;
  if (typeof raw === "number") return raw;
  const s = String(raw).trim();
  if (!s) return NaN;
  const normalized = s.replace(/\$/g, "").replace(/,/g, "");
  const n = Number(normalized);
  return Number.isFinite(n) ? n : NaN;
};

function withMessageFallback(type, params, label) {
  const p = Array.isArray(params) ? [...params] : [];
  if ((type === "required" || type === "typeError") && (p.length === 0 || p[0] == null)) {
    p[0] = `${label ?? "This field"} is required`;
  }
  if (type === "min" && p.length < 2 && label) {
    p[1] = `${label} is required`;
  }
  return p;
}

export function createYupSchema(schema, config) {
  const { id, validationType, validations = [], label } = config;
  let validator;

  if (validationType === "currency") {
    validator = yup
      .string()
      .trim()
      .test("currency-required", `${label ?? "This field"} is required`, (value) => {
        return value !== undefined && value !== null && String(value).trim() !== "";
      })
      .test("currency-valid", `${label ?? "This field"} is required`, (value) => {
        if (value === undefined || value === null || String(value).trim() === "") return false;
        const n = parseCurrency(value);
        return Number.isFinite(n);
      });

    validations.forEach(({ type, params }) => {
      if (type === "min") {
        const p = withMessageFallback(type, params, label);
        const min = Number(p[0] ?? 0);
        const msg = p[1] ?? `${label ?? "This field"} is required`;
        validator = validator.test("currency-min", msg, (value) => {
          const n = parseCurrency(value);
          return Number.isFinite(n) && n >= min;
        });
      }
    });
  } else {
    if (!(yup)[validationType]) {
      return schema;
    }

    validator = yup[validationType]();

    if (validationType === "string") {
      validator = validator.trim();
    }
    if (validationType === "number") {
      validator = validator.transform((val, orig) => {
        return typeof orig === "string" && orig.trim() === "" ? null : val;
      });
    }
    if (validationType === "date") {
      validator = validator.transform((val, orig) => {
        return typeof orig === "string" && orig.trim() === "" ? null : val;
      });
    }

    validations.forEach((validation) => {
      const { type, params } = validation;
      const fn = validator[type];
      if (!fn) return;
      const safeParams = withMessageFallback(type, params, label);
      validator = fn.apply(validator, safeParams);
    });
  }

  schema[id] = validator;
  return schema;
}